<template>
  <div class="search-bar">
    <form class="form" @submit.prevent="search">
      <div class="selected">
        <input class="input-text input-box" v-on:input="$emit('input', $event.target.value)" :value="value" :placeholder="placeHolder">
      </div>
      <button class="search-button" @click="search">
        <div class="published-icon">
          <Fai :icon="['far', 'search']"/>
        </div>
      </button>
    </form>
  </div>
</template>

<script>
    export default {
        name: "Search",
        props: ['search'],

        computed:{
          placeHolder(){
            return this.$route.query.q ? this.$route.query.q : 'Search'
          },
          value(){
            return this.$route.query.q ? this.$route.query.q : ''
          },
        }
    }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .form{
    height: 40px;
    @media #{$mobile} {
      height: 20px;
    }
  }

  .input-box{
    width: 100%;
    border: $gray-1;
    height: 100%;
    background-color: $gray-1;
    text-indent:10px;
    padding: 0;
  }

  .input-box:focus{
    outline: None;
  }

  .published-icon {
    color: white;
    text-align: center;
    height: 100%;
    line-height: 40px;
    @media #{$mobile} {
      line-height: 20px;
    }
    vertical-align: middle
  }
  .search-bar{
    position: relative;
    display: inline-block;
    width: 100%;
    height: 40px;
    @media #{$mobile} {
      height: 20px;
    }
    cursor: pointer;
  }

  .input-text{
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
  }
  .selected {
    display: inline-block;
    width: calc(100% - 40px);
    height: 40px;
    @media #{$mobile} {
      width: calc(100% - 20px);
      height: 20px;
    }
  }
  .search-button {
    display: inline-block;
    width: 40px;
    height: 40px;
    @media #{$mobile} {
      width: 20px;
      height: 20px;
    }
    background: #f46446;
    padding: 0;
    border: 0;
  }
  .search-button:focus {
    outline: None;
  }
</style>
